<div id="health-pkg-flow" class="right-nav showModal">
    <div class="component">
          <ng-container *ngIf="!isRegisterPatient && !openBookAppointment">
            <ng-container [ngSwitch]="index">
                <ng-container *ngSwitchCase="0">
                    <app-health-package [pkgdetails]="pkgdetails" [isWellnessPackageCoupon]="isWellnessPackageCoupon" [selectedPackage]="selectedPackage" [packageOpt]="packageOpt" (close)="checkAction('CLOSE')" (next)="selectedHealthPackage($event)"></app-health-package> 
                </ng-container>
                <ng-container *ngSwitchCase="1">
                <app-health-package-details [selectedPkg]="input['selectedPkg']" (next)="toggleState($event)" (action)="checkAction($event)"></app-health-package-details>
                </ng-container>
                <ng-container *ngSwitchCase="2">
                    <div id="list-patient-component">
                        <div class="header border-bottom spac-btw">
                            <div class="flex">
                                <div (click)="checkAction('BACK')" class="float-left closeicon pointer">
                                    <img src="./assets/icons/arrow.svg">
                                </div>
                                <div class="font-primary-title bold">{{ 'title_select_patient'|translate:'LABELS'}} </div>
                            </div>
                            <div (click)="checkAction('CLOSE')" class="float-right closeicon pointer">
                                <img src="./assets/icons/close_black.svg">
                            </div>
                        </div>
                        <div class="patient-modal-content has-footer">
                            <app-patient-list [linkedPatients]="linkedPatients" [selectedPkg]="input['selectedPkg']" [source]="'PACKAGE'" [packageFacilityId]="input['selectedFacility'] ? input['selectedFacility']['facilityId'] : null" (selcetedPatient)="choosePat($event)" [_selectedPatient]="selectedPatient" ></app-patient-list>
                        </div>
                        <div class="modal-footer">
                            <div class="btn-container">
                                <ng-container  *ngIf="!selectedPatientWithAppt">
                                    <button class="primary-button-outline" (click)="openModal('isRegisterPatient')">{{'hlthpkg_reg_new_pat' | translate}}</button>
                                    <button class="primary-button" [disabled]="!selectedPatient" (click)="setSelectedPatient(selectedPatient)">{{'hlthpkg_continue' | translate}}</button>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="3">
                    <app-mode-of-service class="mode-of-service" [type]="'CHOOSEVISITTYPEFORPACKAGE'" [visitOptions]="visitOptions" (next)="selectedModeOfService($event)" (action)="checkAction($event)"></app-mode-of-service>
                </ng-container>
                <ng-container *ngSwitchCase="4">
                    <app-list-facility [facilityList]="input['facilityList']" (next)="selectedFacility($event)" (action)="checkAction($event)"></app-list-facility>
                </ng-container>
                <ng-container *ngSwitchCase="5">
                    <div id="list-patient-component">
                        <div class="header border-bottom spac-btw">
                            <div class="flex">
                                <div (click)="checkAction('BACK')" class="float-left closeicon pointer">
                                    <img src="./assets/icons/arrow.svg">
                                </div>
                                <div class="font-primary-title bold">{{ 'title_select_time_slot'|translate:'LABELS'}} </div>
                            </div>
                            <div (click)="checkAction('CLOSE')" class="float-right closeicon pointer">
                                <img src="./assets/icons/close_black.svg">
                            </div>
                        </div>
                        <div class="patient-modal-content">
                            <!-- <app-choose-slot [_input]="input" [visitType]="'PACKAGE'" 
                            (complete)="setSlot($event)" [isStandalone]="true"></app-choose-slot> -->
                            <app-health-package-slot [_input]="input" [visitType]="'PACKAGE'" 
                            (complete)="setSlot($event)" [isStandalone]="true"></app-health-package-slot>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="6">
                    <app-health-package-confirm-request [requestInfo]="requestInfo" [healthPkg]="healthPkg" [reqConfirm]="reqConfirm" (action)="checkAction($event)" (switchAction)="editAction($event)" (next)="pkgConfirm($event)"></app-health-package-confirm-request>
                </ng-container>
                <ng-container *ngSwitchCase="7">
                    <app-health-package-confirmation [healthPkg]="healthPkg" [apptConfirmDetails]="apptConfirmDetails" [reqConfirm]="reqConfirm" (action)="redirectToMyPackage($event)" (switchAction)="editAction($event)" (close)="backToHome()"></app-health-package-confirmation>
                </ng-container>
            </ng-container>
            </ng-container>
          <ng-container *ngIf="isRegisterPatient">
            <app-register-new-patient *ngIf="isRegisterPatient" (close)="closeRegPatient($event)"></app-register-new-patient>
          </ng-container>
                    <ng-container *ngIf="isManageIdentities">
                        <div class="tc-modal manageidentities" *ngIf="isManageIdentities">
                            <div class="content">
                                <div class="modal-header-identity border-bottom">
                                    <div class="font-primary-subtitle bold">{{'manage_identities'|translate:'LABELS'}}</div>
                                    <div (click)="closeManageIdentity(false)" class="float-right closeicon pointer">
                                        <img src="./assets/icons/close_black.svg">
                                    </div>
                                </div>
                                <div class="font-default-small manage-content">
                                    <app-manage-identities *ngIf="isManageIdentities" [canDisableRegister]="canDisableRegister()"></app-manage-identities>
                                </div>
                            </div>
                        </div>
                    </ng-container>
          <ng-container *ngIf="openBookAppointment">
                <app-book-appointment *ngIf="openBookAppointment" (next)="selectedPractitioner($event)" (close)="checkAction('CLOSE')" (back)="backToFacilitySelection()" [isHealthPkg]="true" [skipFacilitySelection]="true" [skipPatientSelection]="true" [healthPackage]="healthPkg" [subserviceVisitType]="consultationType" [isMultiplePractCode]="isMultiplePractCode"></app-book-appointment>
          </ng-container>
          <ng-container *ngIf="openConsultationTypeSelection">
            <app-consultation-type-modal *ngIf="openConsultationTypeSelection"   (close)="handleClose()" (confirm)="handleConfirm($event)"></app-consultation-type-modal>          
          </ng-container>
                    <app-contact-us-modal *ngIf="showContactusModal" [contactUs]="true" (close)="showContactusModal = false">
                    </app-contact-us-modal>
                    <app-reusable-alert-popup
                        [visible]="showLinkedPatientLimitPopup"
                        [titleKey]="linkedPatientLimitAlertContent.titleKey"
                        [messageKey]="linkedPatientLimitAlertContent.messageKey"
                        [messageReplace]="{ count: getLinkedPatientLimit() }"
                        [primaryButtonLabelKey]="linkedPatientLimitAlertContent.primaryButtonLabelKey"
                        [secondaryButtonLabelKey]="linkedPatientLimitAlertContent.secondaryButtonLabelKey"
                        (close)="closeLinkedPatientLimitPopup()"
                        (primaryAction)="openContactUsFromLimitPopup()"
                        (secondaryAction)="openManageMyFamilyFromLimitPopup()">
                    </app-reusable-alert-popup>
        </div>
</div>
